declare global {
    interface Window {
        ReactNativeWebView?: { postMessage(message: string): void };
        __FIREFLY_AUTH_TOKEN__?: string;
    }
}

export function isRunningInApp(): boolean {
    return !!window.ReactNativeWebView;
}

export function getAppAuthToken(): string | null {
    return window.__FIREFLY_AUTH_TOKEN__ ?? null;
}

export function notifyApp(type: string, payload?: unknown): void {
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
    }
}
